// extracted by css-extract-rspack-plugin
var _1 = "time-hint-Wfj6tQ";
var _2 = "time-hint-Wfj6tQ";
export { _1 as "time-hint", _2 as "timeHint" }
